import React, { useEffect, useRef, useState } from "react";

function useDropdown() {
  const dropdownRef = {
    state: useRef<HTMLDivElement | null>(null),
    lga: useRef<HTMLDivElement | null>(null),
    options: useRef<HTMLDivElement | null>(null),
    judicial: useRef<HTMLDivElement | null>(null),
    userType: useRef<HTMLDivElement | null>(null),
    status: useRef<HTMLDivElement | null>(null),
    court: useRef<HTMLDivElement | null>(null),

    about: useRef<HTMLDivElement | null>(null),
    management: useRef<HTMLDivElement | null>(null),
    media: useRef<HTMLDivElement | null>(null),
  };

  const [dropdowns, setDropdowns] = useState({
    state: false,
    lga: false,
    options: false,
    judicial: false,
    userType: false,
    status: false,
    court: false,
    about: false,
    management: false,
    media: false,
  });

  useEffect(() => {
    const handleClickOutSide = (event: MouseEvent) => {
      let outSide = true;

      Object.entries(dropdownRef).forEach(([key, value]) => {
        if (value.current?.contains(event.target as Node)) {
          outSide = false;
        }
      });

      if (outSide) {
        setDropdowns({
          state: false,
          lga: false,
          options: false,
          judicial: false,
          userType: false,
          status: false,
          court: false,

          about: false,
          management: false,
          media: false,
        });
      }
    };

    document.addEventListener("mousedown", handleClickOutSide);
    return () => document.removeEventListener("mousedown", handleClickOutSide);
  }, []);

  const closeDropDown = (dropdown: keyof typeof dropdowns) => {
    setDropdowns((prev) => ({ ...prev, [dropdown]: false }));
  };
  return { dropdownRef, dropdowns, setDropdowns, closeDropDown };
}

export default useDropdown;
